import { REMOTASKS_FRONTEND_URL } from '@scale/frontend-lib/constants';

export function getShareUrl(slug: string) {
  return REMOTASKS_FRONTEND_URL + '/share/' + slug;
}
